import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class RetailerTiersService extends BaseService {

  constructor() {
    super();
  }

  getRetailerTiers():Observable<any>{
    return this.httpService.get(APIUrl.retailerTiers);
  }

  getRetailerTierDetails(retailerTierId):Observable<any>{
    return this.httpService.get(`${APIUrl.retailerTiers}${retailerTierId}`);
  }

  createTier(formData):Observable<any> {
    return this.httpService.post(APIUrl.retailerTiers, formData)
  }

  updateTier(formData){
    return this.httpService.put(APIUrl.retailerTiers, formData)
  }

  deleteTier(retailerTierId ){
    return this.httpService.delete(`${APIUrl.retailerTiers}${retailerTierId}` )
  }
}
